import { CallbackType, FRWebAuthn, StepType, WebAuthnStepType } from '@forgerock/javascript-sdk/lib';
import { nextStepWithChecks, progressToChannelSelect } from '../commonSteps';
import { getCallbackOfTypeSafely } from '../../../../utils/authTreeUtils';
import AuthTreeError from 'utils/authTree/AuthTreeError';
import { WEBAUTHN_CANCEL_MESSAGE } from 'utils/constants';

export default async function chooseChannel(dispatch, step, otpChannel) {
  let currentStep = step;

  const choiceCallback = getCallbackOfTypeSafely(currentStep, CallbackType.ChoiceCallback);
  if (!choiceCallback) {
    return currentStep;
  }

  choiceCallback.setChoiceIndex(otpChannel);
  currentStep = await nextStepWithChecks(dispatch, currentStep);

  const webAuthnStep = FRWebAuthn.getWebAuthnStepType(currentStep);
  if (webAuthnStep === WebAuthnStepType.Authentication) {
    try {
      // Authenticate with a registered device
      currentStep = await FRWebAuthn.authenticate(currentStep);
    } catch (error) {
      if (error?.message?.includes(WEBAUTHN_CANCEL_MESSAGE)) {
        // Seems to be the only way to handle User cancelling out of WebAuthn popup
        return null; // Because there's no need for navigation in OnDemandSelectChannelPage
      }
    }
    currentStep = await nextStepWithChecks(dispatch, currentStep);
    if (currentStep.type === StepType.LoginSuccess) {
      window.location.href = currentStep.payload.successUrl;
    } else {
      // "nextStepWithChecks" would take care of redirection/error handling
      // If the control comes here, that means WebAuthn wasn't successfull
      throw new AuthTreeError();
    }
    return null;
  } else {
    currentStep = await progressToChannelSelect(dispatch, currentStep);
    return currentStep;
  }
}
